import type { ReactNode } from "react";
import type { IconName } from "../icons";
import { cn } from "../lib/cn";
import { Icon } from "./icon";

export interface StatDelta {
  direction: "up" | "down";
  /** e.g. "+18% vs last week" */
  label: string;
  /** Whether this change is good news (drives tone; icon + text always shown). */
  positive: boolean;
}

export interface StatCardProps {
  label: string;
  value: ReactNode;
  icon?: IconName;
  delta?: StatDelta;
  footnote?: ReactNode;
  className?: string;
}

export function StatCard({ label, value, icon, delta, footnote, className }: StatCardProps) {
  return (
    <div className={cn("card card-body", className)}>
      <div className="flex items-center justify-between">
        <span className="stat-label">{label}</span>
        {icon ? <Icon name={icon} className="text-fg-subtle" /> : null}
      </div>
      <div className="stat-value">{value}</div>
      {delta ? (
        <div
          className={cn(
            "mt-1 flex items-center gap-1 text-xs font-semibold",
            delta.positive ? "text-success" : "text-danger",
          )}
        >
          <Icon name={delta.direction === "up" ? "trending-up" : "trending-down"} className="size-3.5" />
          {delta.label}
        </div>
      ) : null}
      {footnote ? <div className="mt-1 text-xs text-fg-subtle">{footnote}</div> : null}
    </div>
  );
}
